import dayjs from 'dayjs';

export interface ICallback {
  id?: number;
  celularCliente?: string | null;
  certBdeM?: string | null;
  certComercioProveedor?: string | null;
  claveInstitucionCliente?: string | null;
  claveRastreo?: string | null;
  concepto?: string | null;
  digitoVerificadorCliente?: string | null;
  horaEnvioMensaje?: dayjs.Dayjs | null;
  horaProcMensajeCobro?: dayjs.Dayjs | null;
  horaSolicitudMensajeCobro?: dayjs.Dayjs | null;
  idMensajeCobro?: string | null;
  monto?: number | null;
  nombreCliente?: string | null;
  numeroCuentaCliente?: string | null;
  resultadoMensajeCobro?: number | null;
  tipoCuentaCliente?: number | null;
  selloDigital?: string | null;
  timestampRecibido?: dayjs.Dayjs | null;
  extra1?: string | null;
  extra2?: string | null;
  extra3?: string | null;
  extra4?: string | null;
  extra5?: string | null;
  extra6?: string | null;
  extra7?: string | null;
  extra8?: string | null;
  extra9?: string | null;
  extra10?: string | null;
  createdDate?: dayjs.Dayjs | null;
}

export const defaultValue: Readonly<ICallback> = {};
